import React from 'react';
import { Users, Shield, Calendar } from 'lucide-react';

function GroupCard({ group, activeTab, theme, fonts, styles }) {
  return (
    <div
      style={styles.groupCard}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
        <div style={{
          background: 'linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)',
          padding: '0.75rem',
          borderRadius: '0.75rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Users size={24} color="white" />
        </div>
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: 0, fontSize: fonts.subtitle, color: theme === "dark" ? "white" : "#1a1a1a" }}>
            {group.groupName}
          </h3>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', fontSize: fonts.small }}>
        {activeTab === "member" ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: 0.7 }}>
            <Shield size={14} />
            <span>Creator: {group.creatorSr}</span>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: 0.7 }}>
              <Shield size={14} />
              <span>ID: {group.id}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: 0.7 }}>
              <Calendar size={14} />
              <span>Created: {new Date(group.created_at).toLocaleDateString()}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default GroupCard;